module.exports = __webpack_public_path__ + "img/112.38588afe.svg";